import getField from '@form/formGenerator'

export const userRegisterSaveUrl = `${import.meta.env.VITE_API_URL}/api/users/register`

export const userRegisterFormObject = {
  fullName: null,
  email: null,
  cellPhone: null,
  roles: null,
  missionId: null
}

export const userRegisterFormFields = (userRegisterFormObject, updateFormObject, updateFormObjectProp, saveForm, errors, isLoading, t, data) => {
  const fields = [
    {
      type: 'text',
      name: 'fullName',
      label: t('labels.full_name'),
      value: userRegisterFormObject.fullName,
      key: 'userRegisterFormObject-fullName',
      cssClass: 'column is-12'
    },
    {
      type: 'email',
      name: 'email',
      label: t('labels.email'),
      value: userRegisterFormObject.email,
      key: 'userRegisterFormObject-email',
      cssClass: 'column is-12'
    },
    {
      type: 'text',
      name: 'cellPhone',
      label: t('labels.cell_phone'),
      value: userRegisterFormObject.cellPhone,
      key: 'userRegisterFormObject-cellPhone',
      cssClass: 'column is-12'
    },
    {
      type: 'radio',
      name: 'roles',
      label: t('labels.roles'),
      value: userRegisterFormObject.roles,
      key: 'userRegisterFormObject-roles',
      cssClass: 'column is-12',
      options: data.userRoles,
      isMultiple: true
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'userRegisterFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(userRegisterFormObject.id),
      key: 'userRegisterFormObject-id'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject, updateFormObjectProp)
  })
}